<template>
  <el-dialog title="完成结果" :visible.sync="returnResultVisible" width="530px" class="returnResult">
    <div class="p-20">
      <el-form ref="form">
        <el-form-item style="margin-bottom: 0;">
          <div class="flex">
            <el-input class="flex-1 font-12-30313a" type="textarea" placeholder="请输入完成结果" v-model="returnContent" resize="none"></el-input>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <div class="btn-30-bd-85-s mr-10" @click="onCloseReturn">取消</div>
      <div class="btn-30-bg-f5971d-s" @click="submitReturn">确定</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'FinishHandle',
  components: {},
  props: ['handleId', 'type'],
  data () {
    return {
      returnResultVisible: false,
      returnContent: null
    }
  },
  created () {},
  mounted () {},
  methods: {
    onCloseReturn () {
      this.returnResultVisible = false
      this.returnContent = ''
    },
    submitReturn () {
      if (this.returnContent === null || this.returnContent === '') {
        this.$message({
          message: '请输入完成结果',
          type: 'warning'
        })
      } else {
        this.axios.post(`${this.$store.state.API_URL_9010}/customerHandleResult/save`, {
          handleId: this.handleId,
          content: this.returnContent,
          type: this.type
        }).then(res => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.onCloseReturn()
            this.$parent.$parent.getHandleList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .returnResult /deep/ .el-textarea__inner{
    padding-left: 10px;
    padding-right: 10px;
    height: 260px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/components/FinishHandle.vue